<template>
    <v-snackbar v-model="isShowSnackbar" location="top" color="error">
        {{ $t('offer_not_available') }}
        <template v-slot:actions>
            <v-btn variant="text" @click="refresh">
                {{ $t('search') }}
            </v-btn>
        </template>
    </v-snackbar>
</template>

<script lang="ts">
    import {EventBus} from '@/utils/event-bus'
    import {Component, Prop, Vue} from 'vue-facing-decorator'

    @Component
    export class RefreshOffersCitizenshipSnackbar extends Vue {
        @Prop() basketItem

        isShowSnackbar = false
        citizenshipId = null

        show(citizenshipId) {
            if (citizenshipId) {
                this.citizenshipId = citizenshipId
                this.isShowSnackbar = true
            }
        }

        async refresh() {
            let hotelId

            try {
                const rs = await this.$api.suggestHotels.get({
                    pattern: this.basketItem.offer.name,
                    limit: 1,
                    locationId: this.basketItem.searchRequest.cityId,
                })
                hotelId = rs.hotels[0]?.id
                // eslint-disable-next-line no-empty
            } catch (e) {}

            hotelsStore.SET_SEARCH_REQUEST({
                ...hotelsStore.searchRequest,
                citizenshipId: this.citizenshipId,
            })

            this.$emit('refresh', hotelId)
            this.isShowSnackbar = false
            this.citizenshipId = null
        }

        mounted() {
            EventBus.$on('SHOW_OFFER_NOT_AVAILABLE_CITIZENSHIP', this.show)
        }

        beforeUnmount() {
            EventBus.$off('SHOW_OFFER_NOT_AVAILABLE_CITIZENSHIP', this.show)
        }
    }

    export default RefreshOffersCitizenshipSnackbar
</script>
